import { defineComponent as a, computed as e } from "vue";
import { getPriceFormatted as r } from "@i22/rocket";
import m from "./td-longtail-vue-components32.js";
import d from "./td-longtail-vue-components54.js";
const T = /* @__PURE__ */ a({
  __name: "cart-sticky",
  props: {
    prices: { default: void 0 },
    priceOptions: { default: void 0 }
  },
  emits: ["add-to-cart"],
  setup(i) {
    const t = i, o = e(() => t.prices || []), c = e(
      () => r(o.value, "DEFAULT", "ONETIME", t.priceOptions)
    ), p = e(
      () => r(o.value, "WAS", "ONETIME", t.priceOptions)
    ), s = e(
      () => r(o.value, "DEFAULT", "MONTHLY", t.priceOptions)
    ), n = e(
      () => r(o.value, "WAS", "MONTHLY", t.priceOptions)
    );
    return { __sfc: !0, props: t, prices: o, price: c, wasPrice: p, priceMonthly: s, wasPriceMonthly: n, Prices: m, AddToCartButton: d };
  }
});
export {
  T as default
};
